import React, { useEffect, useRef, useState } from 'react';

const WhatsAppFloat = () => {
  const [position, setPosition] = useState(null);
  const dragRef = useRef(null);
  const draggedRef = useRef(false);

  useEffect(() => {
    const saved = window.localStorage.getItem('whatsapp-float-position');
    if (saved) {
      try { setPosition(JSON.parse(saved)); return; } catch { window.localStorage.removeItem('whatsapp-float-position'); }
    }
    setPosition({ x: window.innerWidth - 80, y: window.innerHeight - (window.innerWidth < 768 ? 224 : 152) });
  }, []);

  const move = (event) => {
    const drag = dragRef.current;
    if (!drag) return;
    const x = Math.max(8, Math.min(window.innerWidth - 64, drag.x + event.clientX - drag.startX));
    const y = Math.max(8, Math.min(window.innerHeight - 64, drag.y + event.clientY - drag.startY));
    if (Math.abs(event.clientX - drag.startX) > 4 || Math.abs(event.clientY - drag.startY) > 4) draggedRef.current = true;
    setPosition({ x, y });
  };
  const endMove = (event) => {
    if (!dragRef.current) return;
    event.currentTarget.releasePointerCapture?.(event.pointerId);
    dragRef.current = null;
    setPosition((next) => { if (next) window.localStorage.setItem('whatsapp-float-position', JSON.stringify(next)); return next; });
  };

  return <a
    href="https://wa.me/32473183927?text=Hi%204AN%20Studio%2C%20I%20have%20a%20question%20about%20a%20booking"
    target="_blank"
    rel="noopener noreferrer"
    className={`fixed z-50 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1eb954] flex items-center justify-center shadow-2xl transition-transform hover:scale-110 touch-none ${position ? 'bottom-auto right-auto' : 'bottom-24 md:bottom-6 right-6'}`}
    style={position ? { left: position.x, top: position.y } : undefined}
    data-testid="whatsapp-float"
    aria-label="WhatsApp — drag to move"
    title="Drag to move"
    onPointerDown={(event) => { draggedRef.current = false; dragRef.current = { startX: event.clientX, startY: event.clientY, x: position?.x || event.currentTarget.getBoundingClientRect().left, y: position?.y || event.currentTarget.getBoundingClientRect().top }; event.currentTarget.setPointerCapture?.(event.pointerId); }}
    onPointerMove={move}
    onPointerUp={endMove}
    onPointerCancel={endMove}
    onClick={(event) => { if (draggedRef.current) event.preventDefault(); }}
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" className="w-7 h-7 fill-white">
      <path d="M16.001 2.667c-7.363 0-13.334 5.97-13.334 13.334 0 2.363.617 4.665 1.79 6.696L2.667 29.333l6.798-1.782c1.955 1.067 4.16 1.629 6.535 1.629 7.364 0 13.334-5.97 13.334-13.334S23.364 2.667 16.001 2.667zm7.79 18.885c-.336.94-1.965 1.799-2.72 1.895-.696.089-1.577.126-2.542-.16-.586-.174-1.339-.42-2.303-.837-4.054-1.75-6.699-5.83-6.902-6.099-.202-.269-1.638-2.174-1.638-4.147 0-1.973 1.033-2.94 1.4-3.343.336-.37.735-.463.98-.463.245 0 .49.003.703.014.226.011.529-.086.828.632.336.808 1.14 2.79 1.24 2.992.1.202.168.437.034.706-.135.269-.202.437-.404.673-.202.235-.424.526-.606.706-.202.202-.412.42-.177.822.235.404 1.043 1.723 2.239 2.79 1.539 1.373 2.834 1.797 3.235 2 .404.202.639.168.874-.101.235-.269 1.005-1.174 1.274-1.577.269-.404.539-.336.909-.202.37.135 2.35 1.109 2.755 1.31.404.202.673.303.774.471.101.168.101.976-.235 1.915z"/>
    </svg>
  </a>;
};

export default WhatsAppFloat;
